import React, { createContext, useState } from "react";
import axios from "axios";
import { API_BASE_URL, CATEGORY_ADVANCED, CATEGORY_SUBSCRIBER } from "@config/config";


export const PromoContext = createContext({});

const PromoContextProvider = (props) => {
    const { children } = props;

    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [processing, setProcessing] = useState(false);

    const [promoTicketClasses, setPromoTicketClasses] = useState([]);

    const [subscriberPromoOfferDetails, setSubscriberPromoOfferDetails] = useState([]);

    const [isAdvancedPromo, setIsAdvancedPromo] = useState(false);
    const [isSubscriberPromo, setIsSubscriberPromo] = useState(false);
    const [isRegularPromo, setIsRegularPromo] = useState(false);
    const [reUseLimitReached, setReuseLimitReached] = useState(false);

    const [enablePromoIcon, setEnablePromoIcon] = useState(false);
    const [selectedPromo, setSelectedPromo] = useState(null);
    const [appliedPromo, setAppliedPromo] = useState(null);
    const [standardPromoCode, setStandardPromoCode] = useState("");
    const [promoOptions, setPromoOptions] = useState([]);

    // Clears the applied promo so a changed code cannot leave a stale discount.
    const changeStandardPromoCode = (code) => {
        setStandardPromoCode(code);
        setAppliedPromo(null);
    };

    const checkPromoReuse = (promo) => {
        if (promo?.promo_category !== CATEGORY_ADVANCED) {
            setReuseLimitReached(false);
        }

        const redemptionCount = promo?.promo_reuse_count;
        const redemptionLimit = promo?.reuse_limit;
        const capPurchases = promo?.cap_purchases;

        setReuseLimitReached(capPurchases === true && redemptionCount >= redemptionLimit);
    };

    const handleSelectPromo = (promo) => {
        if (!promo) {
            setSelectedPromo(null);
            setAppliedPromo(null);
            setReuseLimitReached(false);

        } else {
            setAppliedPromo(null);
            setSelectedPromo(promo);
            let isLimitReached = false;

            switch (promo?.promo_category) {
                case CATEGORY_SUBSCRIBER:
                    isLimitReached = promo?.tickets_available <= 0;
                    break;
                case CATEGORY_ADVANCED:
                    isLimitReached = promo?.cap_purchases && promo?.promo_reuse_count >= promo?.reuse_limit;
                    break;
            }
            setReuseLimitReached(isLimitReached);
        }
    };

    const fetchApplyPromoAvailability = () => {
        setIsLoading(true);
        return axios
            .get(`${API_BASE_URL}/subscriber-promo-availability`)
            .then(function (response) {
                const data = response?.data ?? {};
                const { hasSubscriberPromo, promoClasses, promoOptions } = data;

                setPromoOptions(promoOptions);
                setEnablePromoIcon(true);
                setPromoTicketClasses(promoClasses);
                setIsLoading(false);

                setIsSubscriberPromo(hasSubscriberPromo);
            })
            .catch(() => {
                setPromoOptions([]);
                setEnablePromoIcon(false);
                setPromoTicketClasses([]);
                setIsLoading(false);

                setIsSubscriberPromo(false);
            });
    };

    const fetchSubscriberPromoOffers = () => {
        setIsLoading(true);
        axios
            .get(`${API_BASE_URL}/promo-code/get-subscriber-promo-orders`)
            .then(function(response) {
                setSubscriberPromoOfferDetails(response?.data?.subscriber_promo_order);
            })
            .catch(() => {
                setSubscriberPromoOfferDetails([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <PromoContext.Provider
            value={{
                errorMessage,
                fetchApplyPromoAvailability,
                isLoading,
                processing,
                setErrorMessage,
                setProcessing,

                isAdvancedPromo,
                setIsAdvancedPromo,
                isRegularPromo,
                setIsRegularPromo,
                setIsSubscriberPromo,
                isSubscriberPromo,

                fetchSubscriberPromoOffers,
                subscriberPromoOfferDetails,
                enablePromoIcon,
                promoTicketClasses,
                setSelectedPromo,
                selectedPromo,
                promoOptions,
                standardPromoCode,
                setStandardPromoCode: changeStandardPromoCode,
                appliedPromo,
                setAppliedPromo,
                handleSelectPromo,
                checkPromoReuse,
                reUseLimitReached,
                setReuseLimitReached,
            }}
        >
            {children}
        </PromoContext.Provider>
    );
};

export default PromoContextProvider;
